import React from 'react';

import {

  useNodesState,
  useEdgesState,
  Node,
  Edge,
} from '@xyflow/react';

import '@xyflow/react/dist/style.css';
import { Target } from 'lucide-react';
import ProjectCaseStudy from '../components/ProjectCaseStudy';

const initialNodes: Node[] = [
  {
    id: '1',
    type: 'input',
    data: { label: 'Email Intake' },
    position: { x: 50, y: 100 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '12px',
      fontSize: '12px',
      fontWeight: 'bold',
      padding: '10px',
    },
  },
  {
    id: '2',
    data: { label: 'Classify Email with Claude API' },
    position: { x: 300, y: 100 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '12px',
      fontSize: '12px',
      fontWeight: 'bold',
      padding: '10px',
    },
  },
  {
    id: '3',
    data: { label: 'Is Cover Song Licensing?' },
    position: { x: 550, y: 100 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '12px',
      fontSize: '12px',
      fontWeight: 'bold',
      padding: '10px',
      clipPath: 'polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)',
      width: '150px',
      height: '80px',
    },
  },
  {
    id: '4',
    data: { label: 'Generate Embeddings with Cohere API' },
    position: { x: 200, y: 300 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '12px',
      fontSize: '12px',
      fontWeight: 'bold',
      padding: '10px',
    },
  },
  {
    id: '5',
    data: { label: 'Retrieve Similar Emails from Pinecone' },
    position: { x: 450, y: 300 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '12px',
      fontSize: '12px',
      fontWeight: 'bold',
      padding: '10px',
    },
  },
  {
    id: '6',
    data: { label: 'Generate Response with AI' },
    position: { x: 700, y: 300 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '12px',
      fontSize: '12px',
      fontWeight: 'bold',
      padding: '10px',
    },
  },
  {
    id: '7',
    data: { label: 'Send Intake Email with Gmail Node' },
    position: { x: 550, y: 500 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '12px',
      fontSize: '12px',
      fontWeight: 'bold',
      padding: '10px',
    },
  },
  {
    id: '8',
    data: { label: 'Route to Alternate Handler' },
    position: { x: 750, y: 100 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '12px',
      fontSize: '12px',
      fontWeight: 'bold',
      padding: '10px',
    },
  },
  {
    id: '9',
    type: 'output',
    data: { label: 'End Workflow' },
    position: { x: 800, y: 500 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '12px',
      fontSize: '12px',
      fontWeight: 'bold',
      padding: '10px',
    },
  },
];

const initialEdges: Edge[] = [
  { id: 'e1-2', source: '1', target: '2', animated: true },
  { id: 'e2-3', source: '2', target: '3', animated: true },
  { id: 'e3-4', source: '3', target: '4', animated: true, label: 'Yes' },
  { id: 'e3-8', source: '3', target: '8', animated: true, label: 'No' },
  { id: 'e4-5', source: '4', target: '5', animated: true },
  { id: 'e5-6', source: '5', target: '6', animated: true },
  { id: 'e6-7', source: '6', target: '7', animated: true },
  { id: 'e7-9', source: '7', target: '9', animated: true },
  { id: 'e8-9', source: '8', target: '9', animated: true },
];

const Index = () => {
  const [nodes, , onNodesChange] = useNodesState(initialNodes);
  const [edges, , onEdgesChange] = useEdgesState(initialEdges);

  return (
    <ProjectCaseStudy
      title="Intent Classification with RAG Intelligence"
      tagline="Emails classified, structured, and answered with grounded AI."
      icon={<Target className="w-7 h-7" />}
      context="A support inbox handled hundreds of emails that needed fast, accurate triage — and replies grounded in internal documentation, not guesswork."
      built="An intent classifier powered by Claude converts each email into structured data. A RAG layer retrieves relevant internal documents via embeddings so generated responses stay accurate and grounded."
      stack={['Claude', 'RAG', 'Embeddings', 'Email integration']}
      highlights={['Accurate intent routing', 'Grounded, document-based replies', 'Structured data for downstream systems']}
      nodes={nodes}
      edges={edges}
      onNodesChange={onNodesChange}
      onEdgesChange={onEdgesChange}
    />
  );
};

export default Index;